import { useEffect, useRef, useState } from "react";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import CTLTable from "application/components/CTLTable";
import { getColumns, Attributes, operationURLS } from "./model";
import DeleteConfirmation from "application/components/DeleteConfirmation";
import CTLAdvancedFilter from "application/components/CTLAdvancedFilter";
import { application } from "globals/endpoints";
import CTLBaseDialogForm from "application/components/CTLBaseDialogForm";
import CTLNotification from "application/components/CTLNotification";
import MultipleCommandReject from "./model/MultipleCommandReject";
import { Box, Button, CircularProgress } from "@mui/material";
import MDTypography from "components/MDTypography";
import ConfirmationApprove from "./model/ApproveConfirmation";
import AuthenticationService from "application/modules/authentication/AuthenticationService";

function ApproveSystemChanges({
  onLoad,
  pageId,
  searchText,
  registerCallBacks,
  pageName,
}) {
  const [controller, dispatch] = useMaterialUIController();
  const { activePage, darkMode } = controller;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [advancedFilters, setAdvancedFilters] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [updateList, setUpdateList] = useState(Date.now());
  const [approved, setApproved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  const selectedRowsRef = useRef([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  useEffect(() => {
    const outputFileName = selectedRowData.map((item) => item.outputFileName);
    selectedRowsRef.current = outputFileName;
  }, [selectedRowData]);
  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks &&
      registerCallBacks({
        openAdvancedFilter: onOpenFilter,
        openForm: onOpenForm,
        MultipleUpdate: onOpenMultiUpdate,
        onMultipleDelete: MultipleDelete,
        onRefresh: onRefresh,
      });
  }, [activePage]);
  const [multiDelete, setMultiDelete] = useState(false);
  const [multiapproved, setMultiApproved] = useState(false);
  const [approvedConfirmation, setApprovedConfirmation] = useState(false);
  function onRowSelectionChange(row) {
    setSelectedRowData(row);
  }

  function onRefresh() {
    setUpdateList(Date.now());
  }
  function MultiApprove() {
    if (!selectedRowsRef.current || selectedRowsRef.current.length === 0) {
      setNotify({
        isOpen: true,
        status: "Please select at least one row",
        type: "warning",
        pagename: "Approve System Changes",
      });
      return;
    }
    setLoading(true);
    application
      .post("/commandApproval/approve", { stringId: selectedRowsRef.current })
      .then((response) => {
        setMultiApproved(false);
        setTimeout(() => {
          setLoading(false);
        }, 5000);
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: "Approve System Changes",
        });
        setUpdateList(Date.now());
      })
      .catch((error) => {
        setLoading(false);
        setNotify({
          isOpen: true,
          status:
            error.response?.data?.message +
            " " +
            error.response?.data?.messageDetail,
          type: "error",
          pagename: "Approve System Changes",
        });
      });
  }
  function MultipleDelete() {
    if (!selectedRowsRef.current || selectedRowsRef.current.length === 0) {
      setNotify({
        isOpen: true,
        status: "Please select at least one row",
        type: "warning",
        pagename: "Approve System Changes",
      });
      return;
    }
    setMultiDelete(true);
  }
  function onOpenBackupDeleteBox() {
    if (!selectedRowsRef.current || selectedRowsRef.current.length === 0) {
      setNotify({
        isOpen: true,
        status: "Please select at least one row",
        type: "warning",
        pagename: "Approve System Changes",
      });
      return;
    }
    setLoading(true);
    application
      .post("/commandApproval/reject", { stringId: selectedRowsRef.current })
      .then((response) => {
        setTimeout(() => {
          setLoading(false);
        }, 5000);
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: "Approve System Changes",
        });
        setUpdateList(Date.now());
        setMultiDelete(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response?.data?.message +
            " " +
            error.response?.data?.messageDetail,
          type: "error",
          pagename: "Approve System Changes",
        });
      });
  }
  function onOpenMultiUpdate() {
    if (!selectedRowsRef.current || selectedRowsRef.current.length === 0) {
      setNotify({
        isOpen: true,
        status: "Please select at least one row",
        type: "warning",
        pagename: "Approve System Changes",
      });
      return;
    }
    setMultiApproved(true);
  }
  function onOpenFilter() {
    setOpenFilter(true);
  }

  function onOpenForm() {
    setApproved(true);
  }

  function onCloseFilter() {
    setOpenFilter(false);
  }

  function onApplyFilter(advancedFilters) {
    const updatedFilters = advancedFilters.map((filter) => {
      if (filter.dataType === "date") {
        const timeSuffix =
          filter.direction === "from"
            ? "T00:01"
            : filter.direction === "to"
            ? "T23:59"
            : "";

        return {
          ...filter,
          value: `${filter.value}${timeSuffix}`,
        };
      }
      return filter;
    });
    setAdvancedFilters(updatedFilters);
    setOpenFilter(false);
  }

  const deleteRow = (row) => {
    setSelectedRow(row);
    setConfirmDelete(true);
  };

  const editRow = (row) => {
    setFormData(row);
    setApprovedConfirmation(true);
  };

  const onAgree = (row) => {
    application
      .post(operationURLS.delete, {
        stringId: [row.outputFileName],
      })
      .then((response) => {
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
        }, 5000);

        setUpdateList(Date.now());
        setNotify({
          isOpen: true,
          status: response.data.message + "" + response.data.messageDetail,
          type: "success",
          pagename: pageName,
        });
      });

    setConfirmDelete(false);
  };

  const onCancel = () => {
    setSelectedRow([]);
    setConfirmDelete(false);
  };

  function onCloseForm() {
    setApproved(false);
  }

  function ApprovedData(row) {
    application
      .post("/commandApproval/approve", { stringId: [formData.outputFileName] })
      .then((response) => {
        setApprovedConfirmation(false);
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
        }, 5000);
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: "Approve System Changes",
        });
        setUpdateList(Date.now());
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response?.data?.message +
            " " +
            error.response?.data?.messageDetail,
          type: "error",
          pagename: "Approve System Changes",
        });
      });
  }

  function onCancelMultipleDelete() {
    setMultiDelete(false);
  }

  function onCancelApproved() {
    setMultiApproved(false);
    setApprovedConfirmation(false);
  }

  const isViewOnly = AuthenticationService.isViewOnlyUser();

  return (
    <MDBox>
      {!isViewOnly && (
      <Box sx={{ display: "flex", justifyContent: "start", gap: 2, mt: 2 }}>
        <Button
          onClick={onOpenMultiUpdate}
          variant="contained"
          disableRipple
          disableElevation
          sx={{
            backgroundColor: "#66BB6A",
            color: "#fff",
            "&:hover": {
              backgroundColor: "darkgreen",
            },
            "&:active": {
              backgroundColor: "#66BB6A !important",
            },
            "&:focus": {
              backgroundColor: "#66BB6A !important",
            },
            "&:visited": {
              backgroundColor: "#66BB6A !important",
            },
            minWidth: "120px",
            height: "36px",
            padding: "4px 12px",
            boxShadow: "none",
          }}
        >
          <MDTypography variant="button" fontSize="0.8rem" fontWeight="bold">
            Approve All Selected
          </MDTypography>
        </Button>

        <Button
          onClick={MultipleDelete}
          variant="contained"
          disableRipple
          disableElevation
          sx={{
            backgroundColor: "crimson",
            color: "#fff",
            "&:hover": {
              backgroundColor: "darkred",
            },
            "&:active": {
              backgroundColor: "crimson !important",
            },
            "&:focus": {
              backgroundColor: "crimson !important",
            },
            "&:visited": {
              backgroundColor: "crimson !important",
            },
            minWidth: "120px",
            height: "36px",
            padding: "4px 12px",
            boxShadow: "none",
          }}
        >
          <MDTypography variant="button" fontSize="0.8rem" fontWeight="bold">
            Reject All Selected
          </MDTypography>
        </Button>
      </Box>
      )}
      <DeleteConfirmation
        entityName="Approve System Changes"
        entityDescription="Are you sure to reject the command?"
        data={selectedRow}
        columns={getColumns(deleteRow, editRow)}
        confirmDelete={confirmDelete}
        onAgree={onAgree}
        onCancel={onCancel}
      />
      <MultipleCommandReject
        entityName="Approve System Changes"
        entityDescription="Are you sure to reject the selected command?"
        confirmDelete={multiDelete}
        onAgree={onOpenBackupDeleteBox}
        onCancel={onCancelMultipleDelete}
      />
      {multiapproved && (
        <MultipleCommandReject
          changeIcon={true}
          entityName="Approve System Changes"
          entityDescription="Are you sure to approve the selected command?"
          confirmDelete={multiapproved}
          onAgree={MultiApprove}
          onCancel={onCancelApproved}
        />
      )}
      {approvedConfirmation && (
        <ConfirmationApprove
          changeIcon={true}
          entityName="Approve System Changes"
          entityDescription="Are you sure to approve the command?"
          confirmDelete={approvedConfirmation}
          onAgree={ApprovedData}
          onCancel={onCancelApproved}
        />
      )}
      {loading ? (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(9, 9, 12, 0.4)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="info" />
          <MDTypography variant="h6" sx={{ mt: 2 }}>
            please wait…
          </MDTypography>
        </Box>
      ) : (
        <CTLTable
          apiURL={operationURLS.list}
          onRowSelectionChange={onRowSelectionChange}
          advancedFilters={advancedFilters}
          columns={getColumns(editRow, deleteRow)}
          entriesPerPage={false}
          canSearch
          defaultSortDirection="asc"
          defaultSortColumn="id"
          pageId={pageId}
          searchText={searchText}
          hasRowSelection={true}
          updateList={updateList}
          refetchInterval={10000}
        />
      )}

      <CTLAdvancedFilter
        entityName="Approve System Changes"
        advancedFilters={advancedFilters}
        columns={getColumns(deleteRow, editRow)}
        applyFilter={openFilter}
        onApplyFilter={onApplyFilter}
        onCloseFilter={onCloseFilter}
      />
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}

export default ApproveSystemChanges;
